import BaseImage from "@components/BaseImage";
import { AIRDROP_VAULT_STRINGS } from "../AirdropVault/constants";
import { STABLE_VAULT_STRINGS } from "../StableVault/constants";
import { HIGH_GROWTH_VAULT_STRINGS } from "../HighGrowthVault/constants";
import { VaultItem } from "./types";

// const AIRDROP_VAULT_POINTS =
//   AIRDROP_VAULT_STRINGS.SECTIONS.PORTFOLIO.POINTS.supported;
const AIRDROP_ASSETS_ACCEPTED = AIRDROP_VAULT_STRINGS.ASSETS_ACCEPTED.list;
const HIGH_GAIN_ASSETS_ACCEPTED =
  HIGH_GROWTH_VAULT_STRINGS.ASSETS_ACCEPTED.list;
const STABLE_VAULT_ASSETS_ACCEPTED = STABLE_VAULT_STRINGS.ASSETS_ACCEPTED.list;

export const getFormattedTvl = (tvl: string) => {
  return tvl && tvl !== "-" ? `$${tvl}` : "-";
};

export const createCoreVaultConfig = (
  hgETH: any,
  agETH: any,
  sbUSD: any,
  isLoadingApy: boolean,
  isLoadingTvl: boolean
): VaultItem[] => [
  {
    key: "stable",
    title: "Stable Gain Vault",
    icon: "/assets/vaults/stableVault.svg",
    description:
      "Put idle stables to work - deposit USDT / USDC, mint sbUSD, earn up to ~20% rewards",
    // rewards: "Stable APY",
    link: "/gain/stable-vault",
    category: "core",
    topRightTag: {
      icon: "/assets/vaults/usd_logo.svg",
      label: "Stablecoin",
      bgColor: "#ccf1ee",
      textColor: "#1A1A1A",
    },
    tags: [
      {
        label: "Total value locked",
        value: getFormattedTvl(sbUSD.formattedTvl),
        isLoading: isLoadingTvl,
      },
      {
        label: "Estimated APR",
        value: sbUSD.formattedApy,
        isLoading: isLoadingApy,
      },
      {
        label: "Assets accepted",
        isLoading: false,
        renderValue: () => (
          <div className="flex items-center gap-1">
            {STABLE_VAULT_ASSETS_ACCEPTED.map((data) => (
              <div
                key={data.key}
                className="flex items-center justify-center -ml-2 first:ml-0  mb-[2px]"
              >
                <BaseImage
                  src={data.iconKey}
                  alt={data.title}
                  width={18}
                  height={18}
                />
              </div>
            ))}
          </div>
        ),
      },
    ],
  },
  {
    key: "yield",
    title: "High Gain Vault",
    insuredLink: HIGH_GROWTH_VAULT_STRINGS.HEADER.INSURED_LINK || undefined,
    icon: "/assets/vaults/hgeth.svg",
    description:
      "Highest rewards on ETH - deposit rsETH / ETH / LSTs, mint hgETH, earn rewards via blue-chip strategies",
    // rewards: "High APY",
    link: "/gain/growth-vault",
    category: "core",
    topRightTag: {
      icon: "/assets/vaults/eth_logo.svg",
      label: "Ethereum",
      bgColor: "#70A1FF66",
      textColor: "#1A1A1A",
    },
    tags: [
      {
        label: "Total value locked",
        value: getFormattedTvl(hgETH.formattedTvl),
        isLoading: isLoadingTvl,
      },
      {
        label: "Estimated APR",
        value: hgETH.formattedApy,
        isLoading: isLoadingApy,
      },
      {
        label: "Assets accepted",
        isLoading: false,
        renderValue: () => (
          <div className="flex items-center gap-1">
            {HIGH_GAIN_ASSETS_ACCEPTED.map((data) => (
              <div
                key={data.key}
                className="flex items-center justify-center -ml-2 first:ml-0  mb-[2px]"
              >
                <BaseImage
                  src={data.iconKey}
                  alt={data.title}
                  width={18}
                  height={18}
                />
              </div>
            ))}
          </div>
        ),
      },
    ],
  },
  {
    key: "airdrop",
    title: "Airdrop Gain Vault",
    icon: "/assets/agETH.png",
    category: "core",
    description:
      "Institutional strategies - deposit rsETH / ETH / LSTs, mint agETH, access exclusive rewards",
    link: "/gain/airdrop-gain",
    topRightTag: {
      icon: "/assets/vaults/eth_logo.svg",
      label: "Ethereum",
      bgColor: "#70A1FF66",
      textColor: "#1A1A1A",
    },
    tags: [
      {
        label: "Total value locked",
        value: getFormattedTvl(agETH.formattedTvl),
        isLoading: isLoadingTvl,
      },
      {
        label: "Estimated APR",
        value: agETH.formattedApy,
        isLoading: isLoadingApy,
      },
      {
        label: "Assets accepted",
        isLoading: false,
        renderValue: () => (
          <div className="flex items-center gap-1">
            {AIRDROP_ASSETS_ACCEPTED.map((data) => (
              <div
                key={data.key}
                className="flex items-center justify-center -ml-2 first:ml-0 mb-[2px]"
              >
                <BaseImage
                  src={data.iconKey}
                  alt={data.title}
                  width={18}
                  height={18}
                />
              </div>
            ))}
          </div>
        ),
      },
    ],
  },
];

export const createPartnerVaultConfig = (): // tacRsETH: any,
// isLoadingApy: boolean,
// isLoadingTvl: boolean
VaultItem[] => [
  // {
  //   key: "tacRsEth",
  //   title: "Tac rsETH Vault",
  //   icon: "/assets/vaults/tacEth.svg",
  //   description:
  //     "Participate in the TAC chain pre-deposit campaign with ETH/stETH/rsETH and earn exclusive Restaking and TAC ecosystem rewards",
  //   link: "https://private.upshift.finance/pools/1/0x419386E3Ef42368e602720CC458e00c0B28c47A7",
  //   category: "partner",
  //   tags: [
  //     {
  //       label: "Total value locked",
  //       value: getFormattedTvl(tacRsETH.formattedTvl),
  //       isLoading: isLoadingTvl,
  //     },
  //     {
  //       label: "Estimated APR",
  //       value: tacRsETH.formattedApy,
  //       isLoading: isLoadingApy,
  //     },
  //   ],
  //   isExternal: true,
  //   isFeatured: false,
  // },
  // {
  //   key: "tacBtc",
  //   title: "Tac BTC Vault",
  //   icon: "/assets/vaults/tacBtc.svg",
  //   description:
  //     "Participate in the TAC chain pre-deposit campaign using cbBTC and receive exclusive TAC ecosystem rewards",
  //   link: "https://private.upshift.finance/pools/1/0xeb402fc96C7ed2f889d837C9976D6d821c1B5f01",
  //   category: "partner",
  //   tags: [
  //     {
  //       label: "Total value locked",
  //       value: getFormattedTvl(tacVaultData.formattedTacTvlBtc),
  //       isLoading: tacVaultData.isLoadingTacTvl,
  //     },
  //     {
  //       label: "Estimated APY",
  //       value: tacVaultData.tacApyBtc,
  //       isLoading: tacVaultData.isLoadingTacApy,
  //     },
  //   ],
  //   isExternal: true,
  //   isFeatured: false,
  //   note: () => (
  //     <div className="py-1 flex items-center gap-2">
  //       <BaseImage
  //         src="/assets/info-warning.svg"
  //         alt=""
  //         height={16}
  //         width={16}
  //         className="mt-0.5 flex-shrink-0"
  //       />
  //       <Typography type="body" variant="xsmall" className="text-[10px]">
  //         Tac BTC vault is not accepting deposits right now
  //       </Typography>
  //     </div>
  //   ),
  // },
  // {
  //   key: "movement",
  //   title: "Movement Vault",
  //   icon: "/assets/vaults/movementL2logo.png",
  //   description:
  //     "Join the pre-deposit campaign for Movement L2 and earn 20% APY in Move rewards, rewards from Concrete and DeFi incentives on top of restaking rewards.",
  //   link: "https://movement.concrete.xyz/ethereum",
  //   category: "partner",
  //   isFeatured: false,
  //   note: () => (
  //     <div className="py-1 flex items-center gap-1">
  //       <BaseImage
  //         src="/assets/info-warning.svg"
  //         alt=""
  //         height={16}
  //         width={16}
  //         className="flex-shrink-0"
  //       />
  //       <Typography type="body" variant="xsmall" className="text-[10px]">
  //         Movement vault is not accepting deposits right now
  //       </Typography>
  //     </div>
  //   ),
  //   tags: [
  //     {
  //       label: "Total value locked",
  //       value: getFormattedTvl(momentVaultData.formattedTvl),
  //       isLoading: momentVaultData.isLoading,
  //     },
  //     {
  //       label: "Estimated APY",
  //       value: "20%+",
  //       isLoading: false,
  //     },
  //   ],
  //   isExternal: true,
  // },
];
